module.exports = __webpack_public_path__ + "img/anan_no.181082e4.png";